import { createSlice } from "@reduxjs/toolkit";
import { fetchFilteredTracks } from "../thunks/trackThunks";

const initialState = {
    tracks: [],
    isLoadingAdvancedFiltering: false,
    error: null,
};

const advancedFilteringSlice = createSlice({
    name: "advancedFiltering",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilteredTracks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFilteredTracks.fulfilled, (state, action) => {
                state.loading = false;
                state.tracks = action.payload;
            })
            .addCase(fetchFilteredTracks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default advancedFilteringSlice.reducer;